import type { IdentityContext } from "@utils/store/user/useUser";

/**
 * v0.7 unified context header.
 *
 * Backend only accepts the prefixed form `context:<id>`. The header is built
 * client-side from `IdentityContext.context_id`; callers should never pass a
 * raw context_id without the prefix.
 *
 * Returns `undefined` when there is no selected context — for endpoints that
 * support "no context" (mixed feed, e.g. OrderList "全部" tab) the absence of
 * the header is the intended signal.
 */
export const buildXContextHeader = (ctx?: IdentityContext | null): string | undefined => {
  if (!ctx) return undefined;
  if (ctx.context_id === undefined || ctx.context_id === null) return undefined;
  return `context:${ctx.context_id}`;
};
